import { equals } from 'ramda';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import { isRequired, isRequiredSelect } from '@@viewHelpers/validations';
import BankInformations from './BankInformations';
import {
  ControlledRadioButton,
  ControlledSelect,
  ControlledSwitch
} from '@@viewCommonComponents/controlled';
import { DashedTitle, PageSubtitle } from '@fasstech/middle-design-system';
import React from 'react';

const PaymentInformations = ({
  paymentDayIsVisible,
  paymentFrequencyIsVisible,
  paymentDayOptions,
  paymentFrequencyOptions,
  getMiddleText,
  getMiddleBoolean
}) => {
  const form = useFormContext();
  const { watch } = form;

  const type = watch('bankAccounts.0.type');

  if (
    !paymentDayIsVisible &&
    form.getValues('bankAccounts.0.debitDay') !== null
  ) {
    form.setValue('bankAccounts.0.debitDay', null, { shouldValidate: true });
  }

  return (
    <>
      <DashedTitle>
        {getMiddleText('PAIEMENTETREMBOURSEMENT_PAIEMENT_TITLE')}
      </DashedTitle>
      <PageSubtitle>
        {getMiddleText('PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_MESSAGE_INFOS')}
      </PageSubtitle>
      {(getMiddleBoolean(
        'PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_CHEQUE_AUTORISE'
      ) ||
        getMiddleBoolean(
          'PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_VIREMENT_AUTORISE'
        )) && (
        <ControlledRadioButton
          id="bankAccounts.0.type"
          name="bankAccounts.0.type"
          form={form}
          label={getMiddleText('PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_LABEL')}
          options={[
            ...(getMiddleBoolean(
              'PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_CHEQUE_AUTORISE'
            )
              ? [
                {
                  value: 'CHEQUE',
                  label: getMiddleText(
                    'PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_CHEQUE_LABEL'
                  )
                }
              ]
              : []),
            {
              value: 'PRELEVEMENT',
              label: getMiddleText(
                'PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_PRELEVEMENT_LABEL'
              )
            },
            ...(getMiddleBoolean(
              'PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_VIREMENT_AUTORISE'
            )
              ? [
                {
                  value: 'VIREMENT',
                  label: getMiddleText(
                    'PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_VIREMENT_LABEL'
                  )
                }
              ]
              : [])
          ]}
          rules={{ ...isRequired }}
          data-testid="PAIEMENTETREMBOURSEMENT_TYPE"
        />
      )}

      {(equals('PRELEVEMENT', type) || equals('VIREMENT', type)) &&
        paymentFrequencyIsVisible && (
        <ControlledSelect
          name="bankAccounts.0.debitFrequency"
          label={getMiddleText(
            equals('PRELEVEMENT', type)
              ? 'PAIEMENTETREMBOURSEMENT_FREQUENCE_PAIEMENT_PRELEVEMENT_LABEL'
              : 'PAIEMENTETREMBOURSEMENT_FREQUENCE_PAIEMENT_VIREMENT_LABEL'
          )}
          form={form}
          options={paymentFrequencyOptions}
          rules={isRequiredSelect(paymentFrequencyOptions)}
          data-testid="PAIEMENTETREMBOURSEMENT_FREQUENCE_PRELEVEMENT"
        />
      )}

      {equals('PRELEVEMENT', type) && (
        <>
          {paymentDayIsVisible && (
            <ControlledSelect
              name="bankAccounts.0.debitDay"
              label={getMiddleText(
                'PAIEMENTETREMBOURSEMENT_JOUR_PRELEVEMENT_LABEL'
              )}
              form={form}
              options={paymentDayOptions}
              rules={isRequiredSelect(paymentDayOptions)}
              data-testid="PAIEMENTETREMBOURSEMENT_JOUR_PRELEVEMENT"
            />
          )}

          {getMiddleBoolean(
            'PAIEMENTETREMBOURSEMENT_TIERS_PAYEUR_EST_NECESSAIRE'
          ) && (
            <ControlledSwitch
              label={getMiddleText(
                'PAIEMENTETREMBOURSEMENT_TIERS_PAYEUR_LABEL'
              )}
              form={form}
              name="thirdPartyPayer"
              data-testid="PAIEMENTETREMBOURSEMENT_TIERS_PAYEUR"
            />
          )}

          <BankInformations
            fieldsPrefix="bankAccounts.0"
            getMiddleText={getMiddleText}
            getMiddleBoolean={getMiddleBoolean}
            isCustomer={true}
          />
        </>
      )}
    </>
  );
};

PaymentInformations.propTypes = {
  paymentDayIsVisible: PropTypes.bool.isRequired,
  paymentFrequencyIsVisible: PropTypes.bool.isRequired,
  displayInformations: PropTypes.number,
  setDisplayInformations: PropTypes.func,
  paymentFrequencyRegistred: PropTypes.string
};

export default PaymentInformations;
